export { starterTemplate as starterTemplateStandalone } from './starter-standalone';
export { starterTemplate } from './starter';
export { componentGeneratorTemplate as componentGeneratorTemplateStandalone } from './component-generator-standalone';
export { componentGeneratorTemplate } from './component-generator';
